<div class="card card-custom">
  <div class="card-header justify-content-between">
    <div class="card-title">
      <h3 class="card-label">Attempt to Create a Duplicate Task!</h3>
    </div>
  </div>
  <div class="card-body px-15px py-15">
    <div class="font-size-lg font-weight-bolder mb-10">
      <span class="text-danger mr-2">WARNING:</span>
      <span
        >You are about to create a task with the same template and entities as the tasks listed
        below.</span
      >
    </div>
    <div class="d-flex flex-column border rounded mb-10">
      <div class="d-flex font-weight-bolder bb-light px-15px py-2 mb-15px">
        <span class="flex-grow-1">Title</span>
        <span style="width: 150px" class="ml-4">Due Date</span>
        <span style="width: 100px" class="ml-4">Progress</span>
      </div>
      <div
        style="max-height: 100px"
        class="scroll"
        [perfectScrollbar]="{ wheelPropagation: false }"
      >
        <div *ngFor="let task of matchedTasks" class="d-flex px-15px mb-2">
          <span class="flex-grow-1">
            <span
              matTooltip="View Task"
              matTooltipPosition="above"
              class="text-hover-primary clickable"
              (click)="openTask(task.id)"
              >{{ task.title }}</span
            >
          </span>
          <span style="width: 150px" class="ml-4">{{
            task.due_date ? (task.due_date | date : 'MMM dd, yyyy hh:mm a') : ''
          }}</span>
          <span style="width: 100px" class="ml-4">{{ task.progress | enumFormat : '_' }}</span>
        </div>
      </div>
    </div>
    <div>
      <span class="font-weight-bolder mr-2">Are you sure you want to proceed?</span>
      <span>By hitting Confirm, this task will be created.</span>
    </div>
  </div>
  <div class="card-footer justify-content-end">
    <button mat-raised-button type="button" class="btn btn-sm btn-light" (click)="close($event)">
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      type="button"
      class="btn btn-sm btn-primary ml-15px"
      (click)="close($event, true)"
    >
      {{ 'GLOBAL.CONFIRM' | translate }}
    </button>
  </div>
</div>
